// Initialize Firebase Storage
import {
  getStorage,
  ref,
  uploadBytes,
  deleteObject,
  listAll,
} from "firebase/storage";
import { initializeApp } from "firebase/app";
import { getStorage, ref, getDownloadURL } from "firebase/storage";

// Initialize Firebase app
const firebaseConfig = {
  apiKey: "AIzaSyD7SHFAIzoI8CNGbFmMeHZBfj8AgAlsMNw",
  authDomain: "zrozumiecpsieemocje.firebaseapp.com",
  projectId: "zrozumiecpsieemocje",
  storageBucket: "zrozumiecpsieemocje.appspot.com",
  messagingSenderId: "1064173396236",
  appId: "1:1064173396236:web:47f9659ef5c1f6240b6929",
  measurementId: "G-D038YQHZVF",
};

const app = initializeApp(firebaseConfig);

// Initialize Firebase Storage module
const storage = getStorage(app);

const handleCloseModal = () => {
  const closer = document.querySelector(".close-image");
  const modal = document.querySelector("#image-modal");
  modal.classList.add("is-hidden");
  closer.removeEventListener("click", handleCloseModal);
  document.removeEventListener("keydown", handleKeyDown);
};

const handleKeyDown = (event) => {
  if (event.key === "Escape") {
    handleCloseModal();
  }
};

const handleGalleryItemClick = (event) => {
  const modal = document.querySelector("#image-modal");
  const modalImg = document.querySelector(".modal-content");
  const closer = document.querySelector(".close-image");

  modal.classList.remove("is-hidden");
  modalImg.src = event.target.src;

  closer.addEventListener("click", handleCloseModal);
  document.addEventListener("keydown", handleKeyDown);
};

const generateGallery = async () => {
  const storageRef = ref(storage, "certyfikaty/");
  const files = await listAll(storageRef);

  files.items.forEach(async (fileRef) => {
    const url = await getDownloadURL(fileRef);

    const galleryElement = document.createElement("a");
    galleryElement.classList.add("gallery__item");
    galleryElement.classList.add("gallery__item--height-fit");
    // galleryElement.href = url;
    galleryElement.innerHTML = `<img
            class="gallery__image"
            src=${url}
            alt=""
            title=""
          />`;
    galleryElement.addEventListener("click", handleGalleryItemClick);

    const gallery = document.querySelector(".gallery");
    gallery.insertAdjacentElement("beforeend", galleryElement);
  });
};

generateGallery();
